module.exports = __webpack_public_path__ + "static/media/sliders-v.ab52d815.svg";